import { ErrorCode } from 'dygc'
import { createPopup } from '@/assets/js/factory'
import OverlayTip from '@/components/overlay/OverlayTip'
import OverlayQrCode from '@/components/overlay/OverlayQrCode'
import OverlayPassword from '@/components/overlay/OverlayPassword'
import ForceLocation from '@/components/overlay/ForceLocation'
import OverlayOnlyWeixin from '../../components/overlay/OverlayOnlyWeixin'
import AwardError from '@/components/overlay/AwardError'
import Authorization from '@/components/overlay/Authorization'
import OverlayQrCodeFollow from '@/components/overlay/OverlayQrCodeFollow'
import Breakpoint from '@/components/overlay/Breakpoint'
import OverlayRestart from '@/components/overlay/OverlayRestart'
import MessageBox from '../../components/overlay/MessageBox.vue'
import AgreeInfo from '../../components/overlay/AgreeInfo.vue'

const map = new WeakMap()

export function overlay({ code, message, data, ...propsData }) {
  if (code === ErrorCode.FansNormal) {
    return createPopup(OverlayTip, {
      text: message
    })
  } else if (code === ErrorCode.FansQr) {
    return createPopup(OverlayQrCode, {
      url: data,
      message,
      ...propsData
    })
  } else if (code === ErrorCode.FOLLOW) {
    return createPopup(OverlayQrCodeFollow, {
      url: data,
      message
    })
  } else if (code === ErrorCode.PASSWORD) {
    let vm = map.get(OverlayPassword)
    if (!vm) {
      vm = createPopup(OverlayPassword)
      vm.$on('close', () => {
        map.delete(OverlayPassword)
      })
    }
    vm.onUpdate(message, data)
    map.set(OverlayPassword, vm)
    return vm
  } else if (code === ErrorCode.FORCE_LOCATION) {
    let vm = map.get(ForceLocation)
    if (!vm) {
      const vm = createPopup(ForceLocation)
      vm.$on('close', () => {
        map.delete(ForceLocation)
      })
    }
    return vm
  } else if (code === ErrorCode.ONLY_WEIXIN) {
    return createPopup(OverlayOnlyWeixin)
  } else if (code === ErrorCode.AWARD_ERROR) {
    return createPopup(AwardError, { data })
  } else if (code === ErrorCode.AUTHORIZATION) {
    return createPopup(Authorization)
  } else if (code === ErrorCode.BREAKPOINT) {
    return createPopup(Breakpoint, { data })
  } else if (code === ErrorCode.RESTART) {
    return createPopup(OverlayRestart)
  } else if (code === ErrorCode.ERROR_MESSAGE_OVERLAY) {
    return createPopup(MessageBox, { data })
  } else if (code === ErrorCode.AGREE_INFO) {
    return createPopup(AgreeInfo, {option: data })
  }
}
